import entries from "@Object/entries";
import clone from "lodash/clone"

export default function manageClassToPassengersMapping() {
    /**
     * gets the passenger in the classToPassengers mapping
     */
    const findPassengerInClassToPassengersMapping = (
        classesToPassengersMap: Record<string, (number[])[]>,
        passengerId: number
    ) => {
        let passengerIdIndex = -1;
        let passengerIdGroupIndex = -1;

        const passengersClassToPassengerMapping = entries(classesToPassengersMap).find(([_classId, groupedPassengersIds]) => (
            groupedPassengersIds.some((passengerIds, groupIndex) => {
                const index = passengerIds.indexOf(passengerId)
                if (index !== -1) {
                    passengerIdIndex = index
                    passengerIdGroupIndex = groupIndex
                    return true
                }
                return false
            })
        ))

        return {
            passengersClassToPassengerMapping,
            passengerIdGroupIndex,
            passengerIdIndex,
        }
    }

    /**
     * find and remove passengerId from classToPassengersMap
     */
    const removePassengerFromPreviousClassGroup = (
        classesToPassengersMap: Record<number, (number[])[]>,
        passengerIndex: number
    ) => {
        const newClassesToPassengersMap: Record<number, (number[])[]> = clone(classesToPassengersMap)

        const {
            passengersClassToPassengerMapping: previousPassengersClassToPassengerMapping,
            passengerIdGroupIndex,
            passengerIdIndex,
        } = findPassengerInClassToPassengersMapping(newClassesToPassengersMap, passengerIndex)

        if (!previousPassengersClassToPassengerMapping) {
            return newClassesToPassengersMap
        }

        newClassesToPassengersMap[previousPassengersClassToPassengerMapping[0]][passengerIdGroupIndex].splice(passengerIdIndex, 1)

        if (!newClassesToPassengersMap[previousPassengersClassToPassengerMapping[0]][passengerIdGroupIndex].length) {
            newClassesToPassengersMap[previousPassengersClassToPassengerMapping[0]].splice(passengerIdGroupIndex, 1)

            if (!newClassesToPassengersMap[previousPassengersClassToPassengerMapping[0]].length) {
                delete newClassesToPassengersMap[previousPassengersClassToPassengerMapping[0]]
            }
        }

        return newClassesToPassengersMap
    }

    /**
     *
     */
    const addPassengersToNewClassGroup = (
        classesToPassengersMap: Record<number, (number[])[]>,
        classId: number,
        passengersIds: number[],
        passengerIdGroupIndex?: number
    ) => {
        if (!classesToPassengersMap[classId]) {
            return {...classesToPassengersMap, [classId]: [passengersIds]}
        }

        if (passengerIdGroupIndex !== undefined && !!classesToPassengersMap[classId][passengerIdGroupIndex]) {
            const modifiedClassesToPassengersMap = clone(classesToPassengersMap)

            modifiedClassesToPassengersMap[classId][passengerIdGroupIndex] = [
                ...classesToPassengersMap[classId][passengerIdGroupIndex],
                ...passengersIds,
            ]

            return {...modifiedClassesToPassengersMap}
        }

        return {...classesToPassengersMap, [classId]: [...classesToPassengersMap[classId], passengersIds]}
    }

    return {
        findPassengerInClassToPassengersMapping,
        addPassengersToNewClassGroup,
        removePassengerFromPreviousClassGroup,
    }
}